// extracted by mini-css-extract-plugin
module.exports = {"container":"AreapageSituationsLayout_container__GhpBV","situations":"AreapageSituationsLayout_situations___OKpo","header":"AreapageSituationsLayout_header__h8W7y"};